import React from 'react';
import './styles.scss';
import Group from '../../assets/svg/group.svg';
import {ReactComponent as GitHubIcon} from '../../assets/svg/github.svg';

export default function(props) {
    return (
        <div className="section members">
            <h1>Our Team</h1>
            <img className="group" src={Group}/>

            <div className="members-list">
                <div className="member">
                    <h3>Aurèle Oulès <a href="https://github.com/aureleoules"><GitHubIcon/></a></h3>
                    <span>Group leader | @aureleoules</span>
                </div>
                <div className="member">
                    <h3>Léo Gervoson <a href="https://github.com/leo-gerv"><GitHubIcon/></a></h3>
                    <span>C# Developer | @leo-gerv</span>
                </div>
                <div className="member">
                    <h3>Raphäel Brenn <a href="https://github.com/gtrapha"><GitHubIcon/></a></h3>
                    <span>Unity Developer | @gtrapha</span>
                </div>
            </div>
            

        </div>
    )
}